<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <h5 style="font-weight: bold;font-size: 1.5rem;opacity: 0.8">{{$t('managePackage.h5')}}</h5>
        </div>
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
                  @input="updateSearchQuery" :placeholder="$t('managePackage.place')"/>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue style="height: 55vh"
                   ref="agGridTable"
                   :components="components"
                   :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table"
                   :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="packages"
                   :animateRows="true"
                   :pagination="true"
                   :paginationPageSize="20"
                   :onGridReady="onGridReady"
                   :suppressPaginationPanel="true">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="currentPage"/>
    </div>
  </div>
</template>

<script>
  import {AgGridVue} from "ag-grid-vue"
  import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
  import CellRendererPackageActions from "./cell-renderer/CellRendererPackageActions.vue"
  import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue"

  export default {
    components: {
      AgGridVue,

      // Cell Renderer
      CellRendererPackageActions,
      CellRendererStatus
    },
    data() {
      return {
        searchQuery: "",
        maxPageNumbers: 6,
        // AgGrid
        gridApi: null,
        gridOptions: {},
        defaultColDef: {},
        columnDefs: [
          {
            headerName: 'ID',
            field: 'userId',
            width: 80
          },
          {
            headerName: this.$t('managePackage.userName'),
            field: 'fullName',
            width: 100
          },
          {
            headerName: this.$t('managePackage.namePackage'),
            field: 'namePackage',
            width: 120
          },
          {
            headerName: this.$t('managePackage.meta'),
            field: 'meta',
            width: 150
          },
          {
            headerName: this.$t('managePackage.createDay'),
            field: 'createdDate',
            width: 100
          },
          {
            headerName: this.$t('managePackage.status'),
            field: 'status',
            width: 100,
            cellRendererFramework: 'CellRendererStatus'
          },
          {
            headerName: this.$t('managePackage.action'),
            field: 'transactions',
            width: 100,
            cellRendererFramework: 'CellRendererPackageActions',
          }
        ],
        // Cell Renderer Components
        components: {},
        packages: [],
        userList: []
      }
    },
    created() {
      this.initScreen();
      this.$eventBus.$on('i18n', (event) =>{
        this.columnDefs[1].headerName =  this.$t('managePackage.userName');
        this.columnDefs[2].headerName =  this.$t('managePackage.namePackage');
        this.columnDefs[3].headerName =  this.$t('managePackage.meta');
        this.columnDefs[4].headerName =  this.$t('managePackage.createDay');
        this.columnDefs[5].headerName =  this.$t('managePackage.status');
        this.columnDefs[6].headerName =  this.$t('managePackage.action');
        this.gridOptions.api.setColumnDefs(this.columnDefs);

      })
    },
    watch: {
      '$store.state.windowWidth'(val) {
        if (val <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (val > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      '$store.state.reduceButton'() {
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 650);
      },
      '$store.state.isAdminRequestPackage'(val) {
        if (val) {
          this.initScreen();
          this.$store.commit('UPDATE_ADMIN_REQUEST_PACKAGE', false);
        }
      },
    },
    computed: {
      totalPages() {
        if (this.gridApi) return this.gridApi.paginationGetTotalPages();
        else return 0
      },
      currentPage: {
        get() {
          if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
          else return 1
        },
        set(val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      }
    },
    methods: {
      updateSearchQuery(val) {
        this.gridApi.setQuickFilter(val)
      },
      onGridReady() {
        if (this.$store.state.windowWidth <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (this.$store.state.windowWidth > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      getAllUser() {
        return new Promise(resolve => {
          this.$vs.loading();
          this.$oauth.post('/user/admin/all').then((response) => {
            this.$vs.loading.close();
            resolve(response.data);
          }).catch((err) => {
            this.$vs.loading.close();
            return this.$vs.notify({
              text: err.response.data.message || err.response.data.error_description || err.response.data.error,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
          });
        })
      },
      async initScreen() {
        this.userList = await this.getAllUser();
        let that = this;
        that.$vs.loading();
        that.$business.get('/user-package/admin-all-register-package').then((res) => {
          that.$vs.loading.close();
          that.packages = res.data;
          that.packages.forEach(pack => {
            pack.fullName = "";
            let user = that.userList.find(value => value.id == pack.userId);
            if(user) {
              pack.fullName = user.fullName;
            }
            pack.namePackage = pack.businessPackage ? pack.businessPackage.name : ""
            pack.meta = pack.businessPackage ? pack.businessPackage.metadata : ""
          });
          setTimeout(() => {
            if (that.$store.state.windowWidth > 1024) {
              that.gridApi.sizeColumnsToFit();
            }
          }, 100);
        }).catch((err) => {
          that.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.message || err.response.error_description || err.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      }
    },
    mounted() {
      this.gridApi = this.gridOptions.api;
    }
  }
</script>
